import { ShoppingBagIcon, Bars3CenterLeftIcon, ShieldCheckIcon, BriefcaseIcon, UserCircleIcon } from "@heroicons/react/24/outline";

const AgentManagementRoutes = [
    {
        path: "agent-management",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Retailer",
        icon: ShoppingBagIcon,
        children: [
            {
                path: "admins",
                fullPath: "agent-management/admins",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Supervisor",
                displayPath: "Retailer > Admins",
                icon: ShieldCheckIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/AgentAdminList"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["agent-admin-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/UserAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-admin-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                 "../../pages/userManagement/users/UserAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-admin--edit"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/details/AgentAdminDetails"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-admin-list", "agent-admin--edit", "agent-admin-delete"],
                    },
                ],
            },
            {
                path: "hunter",
                fullPath: "agent-management/hunter",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "CE",
                displayPath: "Agent Management > CE",
                icon: BriefcaseIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/HunterList"

                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["agent-hunter-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/AgentHunterAddUpdate"

                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-hunter-create"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/details/AgentHunterDetails"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-hunter-list", "agent-hunter-edit", "agent-hunter-delete"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/AgentHunterAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-hunter-edit"],
                    },
                ],
            },
            {
                path: "agent-user",
                fullPath: "agent-management/agent-user",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "User/Retailer",
                displayPath: "Agent Management > User",
                icon: UserCircleIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/AgentList"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["agent-user-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/UserForm/UserAdd.js"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-user-create"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Agent/details/AgentDetails"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-user-list", "agent-user-edit", "agent-user-delete"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/userManagement/users/UserAddUpdate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["agent-user-edit"],
                    },
                ],
            },
        ],
    },
];

export default AgentManagementRoutes;
